export const DEFAULT_VALUES = {
  'square-image': 'https://firebasestorage.googleapis.com/v0/b/agus-tests.appspot.com/o/default%2FIMAGXDEF1.png?alt=media&token=ed29da11-fee8-4e88-b310-8ee957e5b3c5',
  coords: [4.983028, -75.605491],
}